<template>
  <div class="avatar-menu">
    <el-dropdown @command="userOpt" trigger="click">
      <div class="avatar-wrapper">
        <div class="avatar-ring"></div>
        <el-avatar icon="el-icon-user-solid" class="avatar-img" :size="35" :src="avatar"></el-avatar>
      </div>
      <el-dropdown-menu slot="dropdown" class="animated-dropdown">
        <el-dropdown-item command="reset" class="dropdown-item">
          <i class="el-icon-key"></i>
          <span>重置密码</span>
        </el-dropdown-item>
        <el-dropdown-item command="quite" class="dropdown-item">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <reset-password v-if="resetPassword.visible" :dialog-data="resetPassword"/>
  </div>
</template>

<script>
  import ResetPassword from "./dialog/ResetPassword"
  export default {
    name: "AvatarMenu",
    components: {ResetPassword},
    data() {
      return {
        avatar: "",
        resetPassword: {title: "重置密码", visible: false, width: 400},
      }
    },
    methods: {
      userOpt(command) {
        switch (command) {
          case "reset": this.reset();break;
          case "quite": this.quite();break;
        }
      },
      reset() {
        this.resetPassword.visible = true;
      },
      // 注销
      quite() {
        this.openConfirm('退出登录', async () => {
          let res = await this.$Http.logout();
          if (res) {
            this.$router.push({name: "login", params: {isLogout: "1"}}).catch(() => {});
            this.msgSuccess('操作成功！');
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .avatar-menu {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    
    .avatar-wrapper {
      position: relative;
      display: inline-block;
      cursor: pointer;
      
      .avatar-ring {
        position: absolute;
        top: -4px;
        left: -4px;
        right: -4px;
        bottom: -4px;
        border-radius: 50%;
        border: 2px solid transparent;
        background: linear-gradient(135deg, #2563eb, #3b82f6, #60a5fa, #2563eb);
        background-size: 300% 300%;
        animation: ringRotate 4s linear infinite;
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        padding: 2px;
        opacity: 0;
        transition: opacity 0.3s ease;
      }
      
      &:hover .avatar-ring {
        opacity: 1;
      }
      
      .avatar-img {
        background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
        color: white;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        
        &:hover {
          transform: scale(1.1) rotate(5deg);
          box-shadow: 0 4px 15px rgba(37, 99, 235, 0.4);
        }
      }
    }
    
    .el-dropdown {
      font-size: 0;
    }
  }
  
  .animated-dropdown {
    border: none;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    padding: 8px 0;
    overflow: hidden;
    animation: dropdownSlide 0.3s ease-out;
    
    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 5px 20px;
      margin: 2px 8px;
      border-radius: 8px;
      transition: all 0.2s ease;
      
      &:nth-child(1) {
        animation: itemSlide 0.3s ease-out 0.05s both;
      }
      
      &:nth-child(2) {
        animation: itemSlide 0.3s ease-out 0.1s both;
      }
      
      i {
        font-size: 16px;
        color: #2563eb;
        transition: transform 0.2s ease;
      }
      
      span {
        font-size: 14px;
        color: #374151;
        font-weight: 500;
      }
      
      &:hover {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
        transform: translateX(4px);
        
        i {
          transform: scale(1.2) rotate(10deg);
        }
      }
    }
  }
  
  @keyframes ringRotate {
    0% {
      background-position: 0% 50%;
      transform: rotate(0deg);
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
      transform: rotate(360deg);
    }
  }
  
  @keyframes dropdownSlide {
    from {
      opacity: 0;
      transform: translateY(-10px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  @keyframes itemSlide {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>
